if(!customElements.get('image-carousel')) {
  class ComponentImageCarousel extends HTMLElement {
    constructor() {
      super();
      this.slidesWrapper = this.querySelector('.keen-slider');
      this.slides = this.slidesWrapper.children;
      this.transition = this.dataset.transition;
      this.arrows = this.dataset.arrows;
      this.autoplay = this.dataset.autoplay;
      this.automove = parseFloat(this.dataset.automove);
      this.pauseOnHover = this.dataset.pauseOnHover!=='false';
      this.loop = false;
      this.carousel = false;
      this.isInViewPort = false;
      this.needButtonFocus = false;
      this.mutationObserver = null;
      this.lastGridLayout = null;
      this.hoverSlide = this.dataset.hoverSlide === 'true';
      this.hoverSpeed = parseInt(this.dataset.hoverSpeed) || 300; //trans

      setTimeout(()=>{ //The timeout is for the customizer
        this.initCarousel();
      }, 1);

      this.bindCustomizerEvents();
      this.bindHoverEvents();
      this.watchGridLayoutChanges();
    }

    //On mouse over show the second image, on mouse out go back to the first one
    bindHoverEvents() {
      if(!this.hoverSlide) return;
      if(window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;

      this.addEventListener('mouseenter', ()=>{
        this.moveToSlideOnHover(1);
      });
      this.addEventListener('mouseleave', ()=>{
        this.moveToSlideOnHover(0);
      });
    }

    moveToSlideOnHover(index) {
      if(!this.carousel || this.slides.length <= index) return;
      this.carousel.moveToSlideRelative(index, true);
    }


    initCarousel() {
      if(window) {
        // Destroy existing carousel if it exists
        if(this.carousel && typeof this.carousel.destroy === 'function') {
          this.carousel.destroy();
          this.carousel = false;
        }

        //for each slide add class 'keen-slider-slide' to enable keen slider functionality
        Array.from(this.slides).forEach(slide => {
          slide.classList.add('keen-slider-slide');
        });

        if(this.slides.length > 1) {
          this.classList.add('prepared');
          this.carousel = new KeenSlider(this.slidesWrapper, {
            mode: "snap",
            loop: this.loop,
            wheel: false,
            dots: this.querySelector('.keen-dots'),
            prevButton: false,
            nextButton: false,
            customAnimation: this.transition=='fade' ? 'fade' : false,
            setContainerHeight: this.transition=='fade',
            autoplay: this.autoplay,
            automove: this.automove,
            pauseOnHover: this.pauseOnHover
          });
        } else {
          this.slidesWrapper.classList.add('initialized');
        }
      }
    }

    getCurrentSlide() {
      if(this.carousel && this.carousel.currentSlide()) {
        return this.carousel.currentSlide();
      } else {
        return this.slidesWrapper.firstChild;
      }
    }

    watchGridLayoutChanges() {
      // Find the closest collection-grid parent
      const collectionGrid = this.closest('.collection-grid');
      if(collectionGrid) {
        this.lastGridLayout = collectionGrid.getAttribute('data-grid-layout');
        let reinitTimeout = null;
        
        // Watch for changes to data-grid-layout attribute
        this.mutationObserver = new MutationObserver((mutations) => {
          for(const mutation of mutations) {
            if(mutation.type === 'attributes' && mutation.attributeName === 'data-grid-layout' && mutation.target === collectionGrid) {
              const newLayout = collectionGrid.getAttribute('data-grid-layout');
              if(newLayout !== this.lastGridLayout) {
                this.lastGridLayout = newLayout;
                
                // Debounce reinitialize to prevent rapid successive reinits
                clearTimeout(reinitTimeout);
                reinitTimeout = setTimeout(() => {
                  this.initCarousel();
                }, 50);
              }
              break;
            }
          }
        });
        
        // Start observing only the collection grid element itself, not its children
        this.mutationObserver.observe(collectionGrid, {
          attributes: true,
          attributeFilter: ['data-grid-layout'],
          subtree: false
        });
      }
    }

    connectedCallback() {
      // Ensure grid layout watching is set up
      if(!this.mutationObserver) {
        this.watchGridLayoutChanges();
      }
    }

    disconnectedCallback() {
      // Clean up mutation observer
      if(this.mutationObserver) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
      }
      // Destroy carousel
      if(this.carousel && typeof this.carousel.destroy === 'function') {
        this.carousel.destroy();
        this.carousel = false;
      }
    }

    bindCustomizerEvents() {
      if(Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e)=>{
          let index = Array.from(this.slides).findIndex(x=>x==e.target);
          if(index>=0) {
            setTimeout(()=>{
              this.carousel.moveToSlideRelative(index, true, 0)
            }, 10);
          }
        });
      }
    }
  }
  customElements.define('image-carousel', ComponentImageCarousel);
}